<template>
  <div style="background-color: white;padding: 0 20px; position: relative">
    <div style="height: 40px;padding-top: 20px">
      <img style="display: inline-block;height: 24px;vertical-align: middle" src="../assets/img/robot/phone_back.png" @click="goBack()">
      <span style="font-size: 18px;color: #000613;font-weight: 500;display: inline-block;vertical-align: middle;margin-left: 10px">{{ $t('footer.ul_li1') }}</span>
    </div>
    <span style="color: #8E9298; font-size: 16px; display: block; margin-top:20px">{{$t('footer.select_question_type')}}</span>
    <div style="margin-top: 20px; width: 100%; text-align: center">
      <el-radio v-model="selectValue" :label="$t('footer.complain')" border size="medium">{{$t('footer.complain')}}</el-radio>
      <el-radio v-model="selectValue" :label="$t('footer.suggestion')" border size="medium">{{$t('footer.suggestion')}}</el-radio>
      <el-radio v-model="selectValue" :label="$t('footer.fault')" border size="medium">{{$t('footer.fault')}}</el-radio>
      <el-radio v-model="selectValue" :label="$t('footer.other')" border size="medium">{{$t('footer.other')}}</el-radio>
    </div>
    <span style="color: #8E9298; font-size: 16px; display: block; margin-top:20px">{{$t('footer.problem_description')}}</span>
    <div style="position: relative; margin-top: 15px">
      <el-input style="font-size: 14px" type="textarea" :rows="6" :placeholder="$t('footer.please_enter_content')" v-model="feedbackContent" @input="totalinput($event)"></el-input>
      <span style="position:absolute; color: #C0C4C8; font-size: 12px; right: 8px;bottom: 6px">{{ thisNum }}/{{ totalNum }}</span>
    </div>
    <el-upload
        class="avatar-uploader"
        :action="upload"
        name="pic"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload"
        :on-preview="handlePictureCardPreview">
      <img v-if="imageUrl" :src="imageUrl" class="avatar">
      <div v-else class="" style="text-align: center; width: 100px; height: 100px;">
        <img style="width: 28px; height: 23px; margin-top: 25px; text-align: center" src="../assets/img/footer/add_pic.png">
        <span style="display: block;font-size: 12px;margin-top:5px;color: #C0C4C8">{{$t('footer.add_photo')}}</span>
      </div>
    </el-upload>
    <el-button class="submit-btn" type="primary" @click="submit()">{{$t('footer.submit')}}</el-button>
  </div>
</template>

<script>
import {feedbackRequest} from "../server/auth";
import {baseUrl} from "../utils/request";

export default {
  name: "FeedBack",
  data() {
    return {
      selectValue: '',
      feedbackContent: '',
      imageUrl: '',
      thisNum: 0,
      totalNum: 500,
      upload: baseUrl + '/other/uploadImage',
    }
  },
  created() {

  },
  mounted() {
    console.log(this.upload)
  },
  methods:{
    goBack(){
      this.$router.back()
    },
    totalinput(value){
      if (value.length>500){
        this.feedbackContent = value.substr(0, 500)
        this.$message.warning(this.$t('home.enter_maximum'))
      }
      this.thisNum = this.feedbackContent.length
    },
    async submit(){
      if (!this.selectValue){
        this.$message.warning(this.$t('home.question_type'))
        return
      }
      if (!this.feedbackContent){
        this.$message.warning(this.$t('home.enter_description'))
        return
      }
      const res = await feedbackRequest(this.selectValue, this.feedbackContent, this.imageUrl)
      if (res.success){
        this.$message.success(this.$t('home.received_thank'))
      } else{
        this.$message.error(res.message);
      }

    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.data;
      console.log(this.imageUrl)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt12M = file.size / 1024 / 1024 < 12;

      if (!isJPG && !isPNG) {
        this.$message.error(this.$t('home.images_must'));
      }
      if (!isLt12M) {
        this.$message.error(this.$t('home.image_size'));
      }
      return (isPNG || isJPG) && isLt12M;
    },
    handlePictureCardPreview(file,fileList) {
      console.log(12)
    }
  }
}
</script>

<style scoped>

.submit-btn{
  width: 100%;
  background-color: #AB54DB;
  position: relative;
  margin-top: 60px;
  margin-bottom: 60px;
}

>>>.el-radio__input{
  display: none;
  border-radius: 36px;
  /*padding: 10px 20px;*/

}
.is-checked {
  color: white;
  border: none;
  background-color: #AB54DB;
}

.el-radio--medium.is-bordered {
  padding: 0px;
  border-radius: 36px;
  height: 36px;
  margin: 0px auto;
  vertical-align: middle;
  width: 20%;
}
>>>.el-radio__label {
  font-size: 14px;
  vertical-align: middle;
  line-height: 36px;
  padding-left: 0px;
}

>>>.el-radio__input.is-checked+.el-radio__label {
  color: white;
}

.avatar-uploader{
  margin-top: 20px;
  width: 100px;
  height: 100px;
  border: 1px #EAECEF solid;
  border-radius: 1px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

</style>
